import { formatCategoryList, useInitLikedProducts, useLikeProductService } from '@widgets/like-product';
import { UxGoodsCardItemForVerticalProductCard as UxGoodsCardItem } from '@common/product-card';
import { useCatalogProductIdParams, usePdpBaseInfo, usePdpRelatedProductRecommendGroups } from '@domains/pdp-common';

import { useFirstPurchaseDealsUBL } from '../log/useFirstPurchaseDealsUBL';

export const useFirstPurchaseDealsService = () => {
  const param = useCatalogProductIdParams();
  const {
    flags: { is_selected_shop },
  } = usePdpBaseInfo(param);

  const { first_order } = usePdpRelatedProductRecommendGroups({
    catalog_product_id: param.catalog_product_id,
    isSelectedShop: Boolean(is_selected_shop),
  });

  const { onLikeProduct } = useLikeProductService();

  const { productClickUBL, productImpressionUBL, moreClickUBL, savedProductUBL, inAppSavedProductUBL } =
    useFirstPurchaseDealsUBL(param.catalog_product_id);

  const onClickMore = () => moreClickUBL();

  const onClickProduct = (catalog_product_id: string, position: number, log?: string | null) =>
    productClickUBL(catalog_product_id, position, log);

  const onImpressionProduct = (catalog_product_id: string, position: number, log?: string | null) => {
    productImpressionUBL(catalog_product_id, position, log);
  };

  const onSaveProduct = (checked: boolean, item: UxGoodsCardItem, position: number) => {
    const inAppLikeProductPayload = {
      like: checked,
      browsingType: item.browsing_type,
      shopId: Number(item.shop_id),
      shopProductNo: item.shop_product_no,
      catalogProductId: item.catalog_product_id,
      title: item.title || '',
      goodsUrl: item.product_url || '',
      imageUrl: item.image_url || '',
      price: Number(item.final_price),
      discountRate: Number(item.discount_rate),
      isZpay: Boolean(item.zpay),
      isFreeShipping: Boolean(item.free_shipping),
      log: inAppSavedProductUBL(
        checked ? 'save_product' : 'remove_saved_product',
        position,
        item?.catalog_product_id ?? '',
        item.log,
      ),
    };

    const airbridge = {
      brandID: item.shop_id,
      brandName: item.shop_name,
      productID: item.catalog_product_id,
      productName: item.title,
      price: item.final_price,
      categoryID: formatCategoryList(item.managed_category_list, 'id'),
      categoryName: formatCategoryList(item.managed_category_list, 'value'),
    };

    const webLikeProductPayload = {
      checked,
      productData: { catalog_product_id: item.catalog_product_id || '', shop_id: item.shop_id || '' },
      airbridge,
      sendLog: (checked: boolean) =>
        savedProductUBL(checked ? 'save_product' : 'remove_saved_product', position, item.catalog_product_id || ''),
    };

    onLikeProduct({ webLikeProductPayload, inAppLikeProductPayload });
  };
  const firstOrderList = first_order[0]?.goods_carousel.component_list ?? [];

  useInitLikedProducts({
    data: firstOrderList,
    convert: (data) => data.map((value) => value.catalog_product_id ?? ''),
  });

  return {
    isHide: firstOrderList.length === 0,
    title: first_order[0]?.main_title?.text || '',
    subTitle: first_order[0]?.sub_title?.text || '',
    itemList: first_order[0]?.goods_carousel?.component_list ?? [],
    button: {
      text: first_order[0]?.more_button?.text || '',
      landingUrl: first_order[0]?.more_button?.link_url || '',
    },
    onClickMore,
    onClickProduct,
    onImpressionProduct,
    onSaveProduct,
  };
};
